import { get } from 'lodash';

export const getCountryOptions = () => {
  const countriesObjectList = get(
    AlumniConnect,
    ['other_infos', 'select_countries'],
    {},
  );

  return Object.keys(countriesObjectList).map((countryKeyValue) => ({
    label: countriesObjectList[countryKeyValue],
    value: countryKeyValue,
  }));
};
